// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap);"]);
// Module
exports.push([module.id, "\n#school-title[data-v-b5cee8e6] {\n  font-family: 'Roboto Condensed', sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  line-height: 21px;\n}\n.desktop-title[data-v-b5cee8e6] {\n  font-size: 21px;\n}\n.mobile-title[data-v-b5cee8e6] {\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
